import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/header/logo_icon.png'
import _imports_1 from '@/assets/images/header/add_icon.png'


const _hoisted_1 = { class: "my-gold-bg display-s-b display-y-center" }
const _hoisted_2 = { class: "display-y-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "display-y-center" }
const _hoisted_5 = { class: "gold-text" }

import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { computed, onBeforeMount, reactive } from 'vue';
import { changeMoney } from '@/utils/currencyUtils';
import { freshBalance } from '@/handle/balanceHandle';
import { addTimer, removeTimer } from '@/handle/timerHandle';
import { LOCAL_STORE } from '@/config/constConfig';


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const { t } = useI18n();

const state = reactive({
    isShowMyInfo: false as boolean
});
//昵称
let nickName = computed(()=> {
    return store.state.nickName;
})
//vip等级
let vipLevel = computed(()=> {
    return store.state.accountInfo.vipLevel;
})
//余额
let gold = computed(()=> {
    return changeMoney(store.state.accountInfo.gold);
})

function isShowGold() {
    let path = route.path;
    if (path.indexOf('/userInfo') != -1) {
        return false;
    }
    return true;
}

onBeforeMount(() => {
    addTimer("freshBalance", ()=> {
        if (store.state.token) {
            let isFresh = localStorage.getItem(LOCAL_STORE.IS_SHOW_NEWPLAYER);
            if (isFresh == "1") {
                freshBalance();
                removeTimer("freshBalance");
            }
        }
    }, 500);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header-content display-y-center display-s-b", (_unref(store).state.isShowPWA&&_unref(route).path=='/')?'show-PWA':''])
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "display-y-center" }, [
      _createElementVNode("img", {
        class: "logo",
        src: _imports_0
      })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "gold-icon",
          src: require('@/assets/images/common/' + _unref(t)('home.img.1'))
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(gold)), 1)
      ]),
      _createElementVNode("div", {
        class: "btn-add display-y-center display-x-center",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/deposit')))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("img", { src: _imports_1 }, null, -1)
      ]))
    ])
  ], 2))
}
}

})